import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import {
    IAlertRule,
    IAlertRuleConfiguration,
    ICreateAlertRuleConfigurationRequest,
    IUpdateAlertRuleConfigurationRequest,
} from '../../entities/Alert/Alert';

export class AlertRuleApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/AlertRules`;

    public static apiUrls = {
        alertRules: `${AlertRuleApi.baseApiUrl}`,
    };

    public static async getAlertRules(): Promise<IAlertRule[]> {
        return this.sendApiRequest<IAlertRule[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.alertRules,
        });
    }

    public static async getAlertRuleConfigurations(alertRuleId: number): Promise<IAlertRuleConfiguration[]> {
        return this.sendApiRequest<IAlertRuleConfiguration[]>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.alertRules}/${alertRuleId}/Configurations`,
        });
    }

    public static async createAlertRuleConfiguration(
        alertRuleId: number,
        request: ICreateAlertRuleConfigurationRequest,
    ): Promise<IAlertRuleConfiguration> {
        return this.sendApiRequest<IAlertRuleConfiguration>({
            method: HttpMethodEnum.POST,
            path: `${this.apiUrls.alertRules}/${alertRuleId}/Configurations`,
            data: request as any,
        });
    }

    public static async updateAlertRuleConfiguration(
        configId: number,
        request: IUpdateAlertRuleConfigurationRequest,
    ): Promise<IAlertRuleConfiguration> {
        return this.sendApiRequest<IAlertRuleConfiguration>({
            method: HttpMethodEnum.PUT,
            path: `${this.apiUrls.alertRules}/Configurations/${configId}`,
            data: request as any,
        });
    }

    public static async deleteAlertRuleConfiguration(configId: number): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.DELETE,
            path: `${this.apiUrls.alertRules}/Configurations/${configId}`,
        });
    }

    public static async getJournalAlertConfiguration(journalId: number): Promise<IAlertRuleConfiguration | null> {
        return this.sendApiRequest<IAlertRuleConfiguration | null>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.alertRules}/Journal/${journalId}/Configuration`,
        });
    }

    public static async saveJournalAlertConfiguration(
        journalId: number,
        request: { thresholdDays: number; maxReminders: number; isEnabled: boolean },
    ): Promise<IAlertRuleConfiguration> {
        return this.sendApiRequest<IAlertRuleConfiguration>({
            method: HttpMethodEnum.PUT,
            path: `${this.apiUrls.alertRules}/Journal/${journalId}/Configuration`,
            data: request as any,
        });
    }

    public static async getJournalAlertConfigurations(journalId: number): Promise<IAlertRuleConfiguration[]> {
        return this.sendApiRequest<IAlertRuleConfiguration[]>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.alertRules}/Journal/${journalId}/Configurations`,
        });
    }

    public static async createJournalAlertConfiguration(
        journalId: number,
        request: ICreateAlertRuleConfigurationRequest,
    ): Promise<IAlertRuleConfiguration> {
        return this.sendApiRequest<IAlertRuleConfiguration>({
            method: HttpMethodEnum.POST,
            path: `${this.apiUrls.alertRules}/Journal/${journalId}/Configurations`,
            data: request as any,
        });
    }

    public static async getQuestionnaireAlertConfigurations(questionnaireId: number): Promise<IAlertRuleConfiguration[]> {
        return this.sendApiRequest<IAlertRuleConfiguration[]>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.alertRules}/Questionnaire/${questionnaireId}/Configurations`,
        });
    }

    public static async createQuestionnaireAlertConfiguration(
        questionnaireId: number,
        request: ICreateAlertRuleConfigurationRequest,
    ): Promise<IAlertRuleConfiguration> {
        return this.sendApiRequest<IAlertRuleConfiguration>({
            method: HttpMethodEnum.POST,
            path: `${this.apiUrls.alertRules}/Questionnaire/${questionnaireId}/Configurations`,
            data: request as any,
        });
    }
}
